import { PermissionDeniedPageComponent } from './pages/permission-denied-page/permission-denied-page.component';
import { StaticSectionComponent } from './components/static-section/static-section.component';
import { UserRoleCheckerPipe } from './pipes/user-role-checker.pipe';
import { CookieService } from 'ngx-cookie-service';
import { CommonModule, registerLocaleData } from '@angular/common';
import ar from '@angular/common/locales/ar';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@core/services/language.service';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { DrawerComponent } from './components/drawer/drawer.component';
import { ExpandablePanelComponent } from './components/expandable-panel/expandable-panel.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ModalComponent } from './components/modal/modal.component';
import { SnackBarComponent } from './components/snack-bar/snack-bar.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { StateSectionComponent } from './components/state-section/state-section.component';
import { ClickStopPropagationDirective } from '@shared/directives/click-stop-propagation.directive';
import { ResponsiveDirective } from '@shared/directives/responsive.directive';
import { PaginatorLocalizationUtil } from './utils';
import { DateFormat } from './models/date-format.model';
import { EnumToArrayPipe } from './pipes/enum-to-array.pipe';
import { ResponsivePipe } from './pipes/responsive.pipe';
import { TranslateService } from '@ngx-translate/core';
/**
 * Angular Material
 */
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';

import { DateAdapter, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PageContentComponent } from './components/page-content/page-content.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { FilterButtonComponent } from './components/filter-button/filter-button.component';
import { TabComponent } from './components/tab/tab.component';
import { AddNewButtonComponent } from './components/add-new-button/add-new-button.component';
import { ExportButtonComponent } from './components/export-button/export-button.component';
import { ActionsButtonComponent } from './components/actions-button/actions-button.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { StatusLabelComponent } from './components/status-label/status-label.component';
import { AppDropdownComponent } from './components/dropdown/dropdown.component';
import { NotificationItemComponent } from './components/notification-item/notification-item.component';
import { NotificationComponent } from './components/notification/notification.component';
import { SequenceNumberComponent } from './components/sequence-number/sequence-number.component';
import { PlateNumberComponent } from './components/plate-number/plate-number.component';
import { ListFilterControlsComponent } from './components/list-filter-controls/list-filter-controls.component';
import { YearComponent } from './components/year/year.component';
import { BirthDateComponent } from './components/birth-date/birth-date.component';
import { sortDropdownPipe } from './pipes/sort-dropdown.pipe';
import { GrantAccessDirective } from '@shared/directives/grant-access.directive';
import { FixedSideLayoutComponent } from './components/fixed-side-layout/fixed-side-layout.component';
import { LogoComponent } from './components/logo/logo.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ResetPasswordModalComponent } from './components/reset-password-modal/reset-password-modal.component';
import { FileSizePipe } from './pipes/file-size.pipe';
import { EntityListingComponent } from './components/entity-listing/entity-listing.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { DropdownSearchComponent } from './components/dropdown-search/dropdown-search.component';
import { ParenthesePipe } from './pipes/parenthese.pipe';
import { WelcomeCardComponent } from '@features/dashboard/components/welcome-card/welcome-card.component';
import { RowComponent } from './components/grid/row.component';
import { ColComponent } from './components/grid/col.component';
import { MarkerComponent } from './components/marker/marker.component';
import { CountDownPipe } from './pipes/count-down.pipe';
import { FormatTimePipe } from './pipes/format-time';
import { ColumnOptionsComponent } from './components/shipments-column-options/column-options.component';
import { DurationPipe } from './pipes/duration.pipe';
import { AvatarComponent } from './components/avatar/avatar.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapOverlayComponent } from './components/map-overlay/map-overlay.component';
import { LatLngPipe } from './pipes/LatLng.pipe';
import { ShipmentRequestHistoryComponent } from './components/shipment-request-history/shipment-request-history.component';
import { RequestAndResponseLogComponent } from './components/request-and-response-log/request-and-response-log.component';
import { MinimizableDialogComponent } from './components/minimizable-dialog/minimizable-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MapClustererOverlayComponent } from '@shared/components/map-clusterer/map-clusterer-overlay.component';
import { MapClustererComponent } from '@shared/components/map-clusterer/map-clusterer.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { OTPInputComponent } from './components/otp-input/otp-input.component';
import { AddShipmentButtonComponent } from './components/add-shipment-button/add-shipment-button.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatListModule } from '@angular/material/list';
import { LabeledInfoListComponent } from './components/labeled-info-list/labeled-info-list.component';
import { CardSectionComponent } from './components/card-section/card-section.component';
import { StickyWidgetComponent } from './components/sticky-widget/sticky-widget.component';
import { FeatureFlagDirective } from '@shared/directives/feature-flag.directive';
import { StickyThingDirective } from '@shared/directives/sticky-thing.directive';
import { ElmLogoComponent } from './components/elm logo/elm-logo.component';
import { PrintSectionsComponent } from './components/print-pages/print-sections.component';
import { UploadedFileComponent } from './components/uploaded-file/uploaded-file.component';
import { NotFoundPage } from '@shared/pages/not-found/not-found.page';
import { RectTagComponent } from '@shared/components/rect-tag/rect-tag.component';
import { GoogleMapsStyleComponent } from './components/google-maps-style/google-maps-style.component';
import { DialogLayoutComponent } from './components/dialog-layout/dialog-layout.component';
import { TrapezoidTabsLayoutComponent } from './components/trapezoid-tabs-layout/trapezoid-tabs-layout.component';
import { SortMenuComponent } from './components/sort-menu/sort-menu.component';
import i18n from '@shared/i18n';
import { FilePondModule } from 'ngx-filepond';
import { DragableFile } from './components/dragable-file/dragable-file.component';
import { activityCardComponent } from './components/activity-card/activity-card.component';
import { LabeledInfoItemComponent } from './components/labeled-info-item/labeled-info-item.component';
import { PopoverDirective } from '@shared/directives/popover-directive';
import { NavListComponent } from './components/nav-list/nav-list.component';
import { AvatarMenuComponent } from './components/avatar-menu/avatar-menu.component';
import { LabeledTextComponent } from '@shared/components/labeled-text/labeled-text.component';
import { LabeledTextListComponent } from '@shared/components/labeled-text-list/labeled-text-list.component';
import { SharedComponent } from '@shared/components/shared/shared.component';
import { LabeledAreaComponent } from './components/labeled-card/labeled-area.component';
import { OrderItemsCard } from './components/order-items-card/order-items-card.component';
import { OrdersAccordingComponent } from './components/orders-according/orders-according.component';
import { TooltipListPipe } from './pipes/tooltipList.pipe';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { OverlayModule } from '@angular/cdk/overlay';
import { ShipmentStatusLabelComponent } from './components/shipment-status-label/shipment-status-label.component';
import { ShipmentsSummaryPerTruckComponent } from './components/shipments-summary-per-truck/shipments-summary-per-truck.component';
import { OrderListLineItemsComponent } from './components/order-list-line-items/order-list-line-items.component';
import {
  AppDateInputComponent,
  CheckboxFieldComponent,
  DateRangeComponent,
  DatetimeRangeComponent,
  DropdownFieldComponent,
  FileFieldComponent,
  FormComponent,
  FormFieldGroupComponent,
  LazyDropdownComponent,
  FileInputComponent,
  PlateLettersComponent,
  RadioFieldComponent,
  TextareaFieldComponent,
  TextFieldComponent,
  UploaderComponent,
  DateFieldComponent,
  ToggleFieldComponent,
} from '@shared/components/forms';
import { TimelineComponent } from '@shared/components/timeline/timeline.component';
import { FieldErrorsComponent } from '@shared/components/forms/fields/field-errors.component';
import { FieldDirective } from '@shared/directives/field.directive';
import { PopoverComponent } from '@shared/components/popover/popover.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { provideSvgIcons, SvgIconComponent } from '@ngneat/svg-icon';
import { ICONS } from './constants';
import { ActivityLogTemplateDirective } from '@shared/directives/activity-log-template.directive';
import { ActivityLogListComponent } from '@shared/components/activity-log-list/activity-log-list.component';
import { TimeFieldComponent } from './components/forms/controls/time-field/time-field.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DropdownMenuComponent } from './components/dropdown-menu/dropdown-menu.component';
import { DirectionDirective } from './directives/direction.directive';
import { RiyalCurrencyDirective } from './directives/riyal-currency.directive';
import { DigitsOnlyDirective } from './directives/digits-only.directive';
import { BooleanDisplayPipe } from './pipes/boolean-display.pipe';
import { ChipListComponent } from '@shared/components/chip-list/chip-list.component';
import { AnnouncementBarComponent } from '@shared/components/announcement-bar/announcement-bar.component';
import { AutocompleteGoogleMapsComponent } from './components/autocomplete-google-maps/autocomplete-google-maps.component';
import { InformationBannerComponent } from './components/information-banner/information-banner.component';
import { MaskPhonePipe } from './pipes/mask-phone.pipe';
import { GrantBiddingAccessDirective } from '@shared/directives/grant-bidding-access.directive';
import { MediaLinkDirective } from '@shared/directives/media-link.directive';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaChallengeComponent } from '@shared/components/recaptcha-challenge/recaptcha-challenge.component';

const MATERIAL_MODULES = [
  MatFormFieldModule,
  MatInputModule,
  MatRippleModule,
  MatIconModule,
  MatSelectModule,
  MatSnackBarModule,
  MatToolbarModule,
  MatTabsModule,
  MatButtonModule,
  MatTableModule,
  MatSortModule,
  MatCheckboxModule,
  MatPaginatorModule,
  MatSidenavModule,
  MatProgressSpinnerModule,
  MatExpansionModule,
  MatAutocompleteModule,
  MatTooltipModule,
  MatRadioModule,
  MatBadgeModule,
  MatChipsModule,
  MatMenuModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDividerModule,
  MatCardModule,
  MatButtonToggleModule,
  MatProgressBarModule,
  MatSliderModule,
  MatDialogModule,
  MatStepperModule,
  MatListModule,
  MatSlideToggleModule,
];

const SHARED_MODUlES = [
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  GoogleMapsModule,
  DragDropModule,
  RecaptchaModule,
];

const avatarColors = ['#f1c40f', '#2c3e50', '#95a5a6', '#f39c12', '#1abc9c'];

const COMPONENTS = [
  LoadingComponent,
  SpinnerComponent,
  SnackBarComponent,
  StateSectionComponent,
  ClickStopPropagationDirective,
  ChipListComponent,
  EnumToArrayPipe,
  DrawerComponent,
  ResponsiveDirective,
  ResponsivePipe,
  ModalComponent,
  ConfirmationComponent,
  ExpandablePanelComponent,
  PageContentComponent,
  BreadcrumbComponent,
  SharedComponent,
  FilterButtonComponent,
  TabComponent,
  AddNewButtonComponent,
  ExportButtonComponent,
  ActionsButtonComponent,
  SearchInputComponent,
  StatusLabelComponent,
  AppDropdownComponent,
  NotificationItemComponent,
  NotificationComponent,
  SequenceNumberComponent,
  PlateNumberComponent,
  ListFilterControlsComponent,
  YearComponent,
  BirthDateComponent,
  sortDropdownPipe,
  UserRoleCheckerPipe,
  FileSizePipe,
  StaticSectionComponent,
  PermissionDeniedPageComponent,
  GrantAccessDirective,
  FixedSideLayoutComponent,
  LogoComponent,
  ResetPasswordModalComponent,
  EntityListingComponent,
  PaginationComponent,
  DropdownSearchComponent,
  ParenthesePipe,
  WelcomeCardComponent,
  RowComponent,
  ColComponent,
  MarkerComponent,
  CountDownPipe,
  FormatTimePipe,
  ColumnOptionsComponent,
  DurationPipe,
  AvatarComponent,
  MapOverlayComponent,
  LatLngPipe,
  ShipmentRequestHistoryComponent,
  RequestAndResponseLogComponent,
  MinimizableDialogComponent,
  RequestAndResponseLogComponent,
  LabeledTextComponent,
  LabeledTextListComponent,
  MapClustererOverlayComponent,
  MapClustererComponent,
  OTPInputComponent,
  AddShipmentButtonComponent,
  LabeledInfoListComponent,
  CardSectionComponent,
  StickyWidgetComponent,
  StickyThingDirective,
  FeatureFlagDirective,
  ElmLogoComponent,
  PrintSectionsComponent,
  UploadedFileComponent,
  NotFoundPage,
  RectTagComponent,
  GoogleMapsStyleComponent,
  DialogLayoutComponent,
  DragableFile,
  TrapezoidTabsLayoutComponent,
  SortMenuComponent,
  activityCardComponent,
  LabeledInfoItemComponent,
  PopoverDirective,
  NavListComponent,
  AvatarMenuComponent,
  LabeledAreaComponent,
  OrderItemsCard,
  OrdersAccordingComponent,
  TooltipListPipe,
  ShipmentStatusLabelComponent,
  ShipmentsSummaryPerTruckComponent,
  OrderListLineItemsComponent,
  TimelineComponent,
  PopoverComponent,
  FileInputComponent,
  FormComponent,
  DatetimeRangeComponent,
  DateRangeComponent,
  PlateLettersComponent,
  LazyDropdownComponent,
  UploaderComponent,
  AppDateInputComponent,
  FormFieldGroupComponent,
  FieldErrorsComponent,
  TextFieldComponent,
  TextareaFieldComponent,
  CheckboxFieldComponent,
  FileFieldComponent,
  RadioFieldComponent,
  DropdownFieldComponent,
  FieldDirective,
  IconComponent,
  ActivityLogTemplateDirective,
  ActivityLogListComponent,
  TimeFieldComponent,
  DropdownMenuComponent,
  ToggleFieldComponent,
  DateFieldComponent,
  DirectionDirective,
  RiyalCurrencyDirective,
  DigitsOnlyDirective,
  BooleanDisplayPipe,
  AnnouncementBarComponent,
  AutocompleteGoogleMapsComponent,
  InformationBannerComponent,
  MaskPhonePipe,
  GrantBiddingAccessDirective,
  MediaLinkDirective,
  RecaptchaChallengeComponent,
];

@NgModule({
  declarations: [...COMPONENTS, FileInputComponent, DropdownMenuComponent],

  imports: [
    MATERIAL_MODULES,
    SHARED_MODUlES,
    CommonModule,
    RouterModule,
    NgOtpInputModule,
    FilePondModule,
    CarouselModule,
    OverlayModule,
    SvgIconComponent,
  ],
  exports: [...MATERIAL_MODULES, ...SHARED_MODUlES, ...COMPONENTS],
  providers: [
    CookieService,
    { provide: DateAdapter, useClass: DateFormat },
    {
      provide: MatPaginatorIntl,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) =>
        new PaginatorLocalizationUtil(translateService).getPaginatorIntl(),
    },
    provideSvgIcons(ICONS),
    // { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } },
  ],
})
export class SharedModule {
  constructor(private dateAdapter: DateAdapter<Date>, private languageService: LanguageService) {
    languageService.registerModule(i18n);
    this.languageService.languageChanged.subscribe((language) => {
      dateAdapter.setLocale(language.isoCode); // DD/MM/YYYY
    });
    dateAdapter.setLocale(this.languageService.currentLanguage$.value.isoCode); // DD/MM/YYYY
    registerLocaleData(ar);
  }
}
